import { render, staticRenderFns } from "./modal-comp.vue?vue&type=template&id=35d1f259&scoped=true"
import script from "./modal-comp.vue?vue&type=script&lang=js"
export * from "./modal-comp.vue?vue&type=script&lang=js"
import style0 from "./modal-comp.vue?vue&type=style&index=0&id=35d1f259&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d1f259",
  null
  
)

export default component.exports